export default {
      mounted(el) {
      el.addEventListener('input', (event) => {
        const value = event.target.value;
        const cleaned = value.replace(/\D/g, '') //regex verify only number
        
        if (value !== cleaned) {
          event.target.value = cleaned;
          
          event.target.dispatchEvent(new Event('input'));
          event.target.dispatchEvent(new Event('change'));
        }
      });
  }
}